var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _path13, _circle6, _circle7, _path14, _path15, _path16, _path17, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path18, _ellipse, _path19, _ellipse2, _path20, _path21, _circle16, _circle17, _circle18, _circle19, _path22, _path23, _g3, _path24, _ellipse3, _path25, _path26, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _path27, _path28, _path29, _path30, _path31, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g4, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g5, _circle36, _circle37, _circle38, _circle39, _g6, _g7, _path52, _circle40, _circle41, _path53, _path54, _path55, _path56, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _path57, _path58, _g8, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g9, _path69, _path70, _path71, _path72, _g10, _path73, _path74, _path75, _g11, _g12, _g13, _path76, _g14, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g15, _g16, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g17, _path126, _path127, _path128, _path129, _g18, _g19, _g20, _g21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSrbijaGrb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 100,
    viewBox: "0 0 52 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M43.293 20.635c.275-.597.055-1.43-.037-1.618-.045-.096.092-.306.148-.388 1.873-2.634 1.906-2.869.613-3.855-1.164-.891-3.797-1.757-5.682-2.34-.393-.297-.641-.701-.998-1.034 3.619.258 7.541 1.718 9.521 3.424 1.045.902-.229 2.722-1.785 5.491-.96.689-1.411 1.01-1.78.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M43.863 20.845a4.62 4.62 0 0 0 .182-.681c.078-.39.045-.794-.086-1.174.434-.606.916-1.266 1.268-1.92.25-.467.441-.988.295-1.522-.156-.568-.652-.957-1.102-1.298-.535-.411-1.25-.769-1.977-1.076-1.621-.668-2.91-.995-3.855-1.025l.6.553c1.76.565 3.834 1.31 4.832 2.072 1.293.987 1.26 1.22-.613 3.855-.059.082-.193.292-.148.388.092.188.258 1.057-.02 1.655.159.303.394.143.624.173z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M28.033 9.118c-.018-.334.006-.278.057.237.055-.104.125-.15.211-.148.152.003.244.232.26.753l-.025.397c4.799-.105 7.645.617 8.379 2.006.605 1.143-.424 3.035-1.973 5.195-.188.262-.184.239 0 .455.262.311.545.84.332 1.302.938.514 2.057.639 3.031.213.16-.426.514-.63.797-.823.059-.04.266-.142.287-.208.514-1.635 1.025-3.146 1.467-4.555 1.382-4.421-10.93-4.826-12.823-4.824z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M40.707 28.141c.477-.951.975-1.883 1.643-2.692-1.705 1.26-2.604 1.069-2.729-.571-.102-.035-.238-.035-.375-.035-1.301 2.014-2.566 1.735-3.797-.839-1.678 2.645-3.115 2.598-4.244-.161-1.934 2.41-3.561 2.417-4.884.05v-.299c.073.032.023.042-.15.021l-.028-.055c-.052.01-.099.02-.142.026a7.253 7.253 0 0 0-.144-.026l-.028.055c-.174.023-.224.013-.15-.021v.301c-1.323 2.366-2.952 2.358-4.885-.051-1.129 2.757-2.566 2.805-4.242.161-1.23 2.573-2.497 2.853-3.799.839-.137 0-.271 0-.373.035-.125 1.641-1.022 1.831-2.729.571.665.809 1.165 1.741 1.641 2.692 4.914-.203 9.812-.458 14.709-.714 4.895.255 9.792.51 14.706.713z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M42.723 24.183l-.535-.088c-1.027 2.506-1.947 2.567-2.121.183.229-.082.139-.48.398-.321.137.083.311-.153.195-.286-.291-.213-.551-.18-.803.058-.121-.381-.414-.558-.781-.397-.158.069-.104.353.055.337.258-.026.154.24.234.418-1.824 2.375-2.754 2.093-2.525-1.026-.434-.09-.939-.178-1.393-.339-1.676 3.362-2.867 3.507-3.834.488.205-.154.145-.541.449-.417.17.07.313-.23.162-.358-.355-.297-.736-.197-.994.185-.207-.412-.574-.559-.961-.309-.168.107-.064.424.113.376.342-.091.188.356.445.51-.74 2.838-4.48 3.029-3.869-1.171l-.962.035-.964-.035c.612 4.202-3.129 4.01-3.87 1.171.26-.153.105-.601.447-.51.178.047.282-.269.114-.376-.388-.25-.755-.103-.962.309-.256-.382-.641-.482-.993-.185-.151.128-.011.429.161.358.303-.124.244.263.451.417-.967 3.019-2.159 2.874-3.836-.49-.451.161-.957.249-1.391.339.227 3.119-.705 3.401-2.525 1.026.08-.178-.022-.445.232-.418.159.017.215-.268.055-.337-.367-.162-.66.017-.781.397-.254-.238-.514-.271-.803-.058-.113.131.06.369.195.286.262-.16.17.239.4.321-.174 2.384-1.096 2.323-2.122-.183l-.535.088a2.655 2.655 0 0 0 .553 1.677c1.54 1.953 2.687 1.51 2.728-.677 2.017 2.362 3.543 2.064 3.814-.428 1.697 3.143 4.42 1.639 4.475-.268.748 2.77 4.889 2.751 5.152-.433.266 3.184 4.404 3.203 5.152.433.057 1.907 2.777 3.411 4.475.268.273 2.492 1.799 2.791 3.816.428.043 2.188 1.188 2.63 2.729.677.37-.459.577-1.086.56-1.675z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M29.447 20.986c-.229-.142-.271-.104-.346-.198-.096-.12-.096-.317-.064-.506.119-.761-.34-.655-.854-.317-.258.168-.518.559-.738.763-.223.205-.404.222-.461.302-.006.22-.008.439-.006.659-.002.114-.002.367.006.659.057.081.238.099.461.302.223.204.48.595.738.764.514.336.973.443.854-.319-.029-.188-.029-.386.064-.505.072-.094.117-.055.346-.198a.974.974 0 0 0 .33-.324c.076-.12.035-.25.035-.38s.041-.26-.035-.38a.96.96 0 0 0-.33-.322z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.959 21.804l.021.128c.516.061 1 .28 1.387.626-.26-.381-.818-.668-1.408-.754zm0-.23l.021-.128c.516-.063 1-.282 1.387-.628-.26.384-.818.67-1.408.756z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M29.045 19.937c-.166.067-.348.141-.498.288-.232.225-.084.596.217.955.096.113.143.313.141.513 0 .2-.049.398-.141.508-.301.359-.449.731-.217.955.15.147.332.22.498.287a1.006 1.006 0 0 0-.01-.346c-.029-.188-.027-.386.066-.505.072-.094.117-.055.344-.198a.99.99 0 0 0 .332-.324c.074-.12.035-.25.035-.38s.039-.26-.035-.38a.999.999 0 0 0-.332-.324c-.227-.142-.271-.104-.344-.198-.096-.12-.098-.317-.066-.506a1 1 0 0 0 .01-.345zm-20.339.698c-.275-.597-.054-1.43.037-1.618.045-.096-.09-.306-.148-.388-1.873-2.634-1.906-2.869-.614-3.855 1.167-.891 3.798-1.757 5.683-2.34.392-.297.642-.701.998-1.034-3.621.258-7.543 1.718-9.521 3.424-1.045.902.226 2.722 1.783 5.491.961.689 1.412 1.01 1.782.32z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M8.135 20.845a4.878 4.878 0 0 1-.18-.681 2.213 2.213 0 0 1 .086-1.174c-.433-.606-.918-1.266-1.268-1.92-.25-.467-.443-.988-.295-1.522.156-.568.652-.957 1.102-1.298.534-.411 1.25-.769 1.976-1.076 1.622-.668 2.911-.995 3.856-1.025l-.601.553c-1.758.565-3.834 1.31-4.832 2.072-1.292.987-1.259 1.22.614 3.855.059.082.193.292.147.388-.089.188-.255 1.057.021 1.655-.161.303-.395.143-.626.173z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M23.967 9.118c.017-.334-.006-.278-.057.237-.055-.104-.125-.15-.212-.148-.153.003-.242.232-.258.753l.027.397c-4.799-.105-7.646.617-8.379 2.006-.604 1.143.422 3.035 1.972 5.195.187.262.181.239 0 .455-.263.311-.544.84-.332 1.302-.938.514-2.058.639-3.031.213-.161-.426-.513-.63-.797-.823-.058-.04-.267-.142-.287-.208-.513-1.635-1.026-3.146-1.468-4.555C9.762 9.521 22.07 9.116 23.967 9.118zm.834 18.299l-.172 4.793c4.755.133 10.386.348 15.14.48l.947-4.475c-11.427-.721-16.694-.949-15.915-.798z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M24.801 27.417l-.002.025c-2.539.112-7.037.363-13.52.773l.949 4.475c4.307-.121 9.33-.308 13.771-.44 4.441.133 9.466.32 13.771.44l.947-4.475c-6.48-.41-10.98-.661-13.52-.773l-.002-.025c.256-.05-.141-.059-1.197-.022-1.056-.037-1.455-.028-1.197.022z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M26 27.948l-.524.001-.175.001h-.09l-.162.001h-.098l-.063.001h-.111l-.174.002h-.186l-.129.002-.381.005h-.066l-.162.002-.049.001-.069.001-.166.003h-.007l-.174.003-.057.001-.117.002h-.037l-.135.003-.174.004h-.007l-.166.004h-.071c-.205.005-.41.01-.615.017l-.084.002-.232.007-.025.001-.209.005-.137.004-.098.003h-.026l-.206.008h-.013l-.171.006h-.008l-.164.006-.109.01-.23.009c-.305.012-.608.024-.912.04l-.043.002c-.445.021-.891.043-1.334.068l-.025.001-.066.004c-.888.051-1.771.109-2.648.174l-.033.003h-.012a139.07 139.07 0 0 0-3.821.342c-.72.067-.854-.779 0-.858 1.272-.131 2.547-.245 3.821-.342l.012-.001a145.15 145.15 0 0 1 5.357-.304l.148-.006h.021l.049-.001.171-.006h.013c.739-.026 1.48-.047 2.227-.063l.117-.003h.006l.197-.003h.032l.166-.003.069-.001.104-.002.13-.001.043-.001.062-.001.458-.005.146-.002h.028l.174-.001.509-.002h.014l.175-.001.522-.001.523.001.174.001h.014l.508.002.176.001h.027l.146.002.459.005.063.001.041.001.133.001.104.002.068.001.168.003h.029l.197.003h.006l.117.003c.746.015 1.488.036 2.229.063h.01l.172.006.051.001h.023l.146.006c1.807.069 3.594.17 5.357.304l.012.001c1.287.098 2.563.21 3.822.342.855.079.717.925 0 .858a143.433 143.433 0 0 0-3.822-.342h-.012l-.033-.003c-.881-.066-1.764-.124-2.648-.174l-.064-.004-.025-.001c-.443-.024-.889-.047-1.334-.068l-.045-.002-.912-.04-.23-.009-.109-.004-.164-.006h-.01l-.172-.005h-.012l-.207-.008h-.027l-.098-.003-.137-.004-.207-.006-.025-.001-.234-.006-.082-.002-.615-.017h-.006l-.068-.001-.166-.004h-.008l-.174-.003-.135-.003h-.037l-.117-.006-.057-.001-.172-.003h-.008l-.166-.003-.07-.001-.049-.001-.162-.002h-.066l-.381-.005-.127-.002h-.035l-.15-.001-.176-.002h-.27l-.162-.001h-.09l-.176-.001c-.173-.004-.349-.004-.523-.004z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.797,
    cy: 18.395,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.922,
    cy: 20.266,
    r: 0.858,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.103,
    cy: 18.698,
    r: 0.858,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.331,
    cy: 17.111,
    r: 0.858,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 21.689,
    r: 1.122,
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M20.5 19.198c.496-.033.373.85.274 1.046-.128.257-.246.265-.407.028-.122-.183-.363-1.041.133-1.074z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 0.174,
    d: "M20.532 19.675c1.166-.079.877 1.995.647 2.458-.3.604-.579.623-.96.065-.287-.427-.853-2.445.313-2.523z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M11.131 20.446c.475-.15.565.736.518.95-.063.279-.176.316-.391.124-.164-.148-.601-.924-.127-1.074z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 0.174,
    d: "M11.276 20.901c1.113-.354 1.328 1.729 1.214 2.232-.147.658-.415.742-.916.292-.382-.345-1.411-2.169-.298-2.524z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M23.395 9.921c-2.502-.225-5.061.029-7.594 1.034-2.135.848-1.926 3.322.678 6.757-.236.435-.369.976-.391 1.601.275-.015.468-.008.711-.014-.188-.416.022-.926.261-1.286.155-.234.187-.193 0-.455-1.55-2.161-2.577-4.052-1.972-5.195.733-1.389 3.578-2.112 8.379-2.006l-.026-.384-.046-.052z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.254,
    cy: 11.517,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.002,
    cy: 10.946,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M13.234 10.814l.267.354c-1.408.772-1.99 1.587-1.854 2.407.023.141.452 1.641 1.409 4.547.653.452 1.141.856 1.463 1.211-.037.042.103.167.062.202.099.443-.404.353-.738.244-.163-.427-.656-.88-.94-1.073-.058-.04-.267-.142-.287-.208-.513-1.635-1.026-3.146-1.468-4.555-.444-1.415.517-2.419 2.086-3.129z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M7.676 21.319l-.055.286c-.41.095-.761.119-1.052.072.49-.477.853-.578 1.107-.358z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.177,
    d: "M7.631 20.666c.257.057.281.1.393.12.145.024.344.014.479-.104.557-.335.569.268.354.718-.158.327-.077.696.073.975.177.331.14.481.014.571l-.244.156c-.15.177-.264.147-.285-.084-.557-.229-.74-.763-.906-1.233-.245-.687-1.13-.85.122-1.119z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.194,
    d: "M7.851 20.69c.485.172.538-.097.864-.082-.129.74-.258 1.124-1.032.726-.427-.219-.974.103-1.077.341-.039.086-.286-.093-.377-.292-.378-.831.973-.925 1.622-.693z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.616,
    cy: 8.894,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.797,
    cy: 8.894,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.979,
    cy: 9.036,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.304,
    cy: 9.357,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.276,
    cy: 13.933,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.803,
    cy: 12.97,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.542,
    cy: 12.156,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.092,
    cy: 15.383,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.277,
    d: "M22.698 29.866L26 28.216l3.3 1.65-3.3 1.651-3.302-1.651z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 29.844,
    fill: "#00498F",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    rx: 1.484,
    ry: 0.99
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.277,
    d: "M15.358 30.282l3.193-1.85 3.396 1.446-3.193 1.85-3.396-1.446z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.66,
    cy: 30.066,
    fill: "#D93A43",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    rx: 0.99,
    ry: 1.485,
    transform: "rotate(86.52 18.66 30.066)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M11.514 28.955l3.453 1.307-2.85 1.906c-.738-.246-1.324-2.756-.603-3.213z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00498F",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M11.581 29.589c.816-.083 1.523.291 1.58.835.055.544-.563 1.052-1.378 1.136-.53.054-.86-.411-.918-.902-.059-.492.156-1.012.716-1.069z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.417,
    cy: 30.94,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.338,
    cy: 31.333,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.088,
    cy: 29.193,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.398,
    cy: 28.891,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M9.853 24.277c.353-.107.899.668 1.03.655.173-.443-.18-1.503-.805-2.343-.424-.138-.461-.41-.55-1.042-.026-.189-.389-.059-.396.263-.008.344-.033.535.043.829.031.117.014.227-.116.333.663.26.826.582.794 1.305z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.178,
    d: "M9.54 21.554c-.062.146-.08.265-.094.486a.7.7 0 0 0 .158.466c.107.14.264.263.438.363.106.062.23.234.328.43.098.194.168.414.172.57.015.516.114.967.352 1.056a.462.462 0 0 0 .337.021c-.035-.093-.021-.223-.104-.353-.107-.167-.201-.358-.209-.525-.008-.131-.069-.218-.02-.475.034-.166.143-.229.122-.383-.038-.297-.272-.867-.616-.867-.339 0-.499-.037-.675-.486-.061-.152-.139-.226-.189-.303z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M8.258 22.791c.093-.071.205-.123.31-.165a.85.85 0 0 1 .554-.025c.815.245 1.172 1.681.278 2.027-.176.021-.337-.137-.496-.483-.187-.459-.383-.777-.595-.972-.13-.162-.135-.299-.051-.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M8.67 22.886c.783-.303 1.357 1.186.627 1.468-.394.152-.43-.336-.508-.607-.1-.366-.871-.57-.119-.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00498F",
    strokeWidth: 0.174,
    d: "M8.752 23.106c.381-.146.905.74.428.942-.323.137-.578-.042-.682-.31-.103-.267-.014-.528.254-.632z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.277,
    d: "M36.641 30.282l-3.193-1.85-3.398 1.446 3.195 1.85 3.396-1.446z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.346,
    cy: 30.062,
    fill: "#D93A43",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    rx: 0.991,
    ry: 1.485,
    transform: "rotate(93.503 33.346 30.063)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M40.484 28.955l-3.453 1.307 2.852 1.906c.738-.246 1.322-2.756.601-3.213z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#00498F",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M40.418 29.589c-.813-.083-1.521.291-1.578.835-.055.544.561 1.052 1.377 1.136.531.054.861-.411.92-.902.056-.492-.158-1.012-.719-1.069z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.584,
    cy: 30.94,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.66,
    cy: 31.333,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.91,
    cy: 29.193,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6,
    cy: 28.891,
    r: 0.464,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.084,
    cy: 16.881,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.411,
    cy: 15.346,
    r: 0.925,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.624,
    cy: 9.902,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.125,
    cy: 10.615,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.023,
    cy: 11.922,
    r: 0.925,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.844,
    cy: 13.567,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M26.454 2.3a.454.454 0 1 0-.002-.903.454.454 0 1 0-.904 0 .452.452 0 0 0 0 .903v.926h-.798a.454.454 0 0 0-.904-.009.45.45 0 1 0 .001.901.452.452 0 0 0 .902.01h.797v3.08h.906V4.131h.796a.64.64 0 1 0 .902-.912.452.452 0 0 0-.904.011h-.794l.002-.93z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#00498F",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175,
    d: "M26 10.193a2.495 2.495 0 0 0 2.49-2.492A2.496 2.496 0 0 0 26 5.208a2.5 2.5 0 0 0-2.494 2.493A2.5 2.5 0 0 0 26 10.193z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175,
    d: "M26 5.208c.153 0 .306.014.453.042v1.962h-.906V5.249c.15-.028.301-.041.453-.041z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M28.441 7.194c.057.283.064.574.025.859A72.39 72.39 0 0 0 26 8.006c-.828 0-1.648.02-2.469.047a2.479 2.479 0 0 1 .026-.859 73.545 73.545 0 0 1 2.44-.046c.816.001 1.63.016 2.444.046z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M24.065 9.259c-.527-.326-.62.178-.605.684.049 1.908.414 3.722-.1 6.057-.206.934-.537 1.46-.213 1.641.822.459 1.2.88 1.068 1.105.244.464.851.374 1.785.226.933.148 1.539.238 1.783-.226-.133-.225.246-.646 1.07-1.105.32-.181-.01-.706-.215-1.641-.516-2.335-.148-4.15-.1-6.057.014-.506-.078-1.01-.605-.684-1.04.64-2.815.647-3.868 0z"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 17.426,
    r: 0.99,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 15.709,
    r: 0.99,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14.058,
    r: 0.99,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 9.37,
    r: 0.99,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 10.823,
    r: 0.99,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12.408,
    r: 0.99,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M24.877 18.603c-.393-.726-.809-1.189-1.25-1.391.606-1.896.75-4.345.393-7.363-.035-.452-.146-.646-.32-.643-.152.003-.244.232-.259.753.11 1.661.246 3.114.169 4.347-.066 1.102-.328 2.017-.615 3.048-.039.143.063.256.563.535.368.208.6.464.677.73a.316.316 0 0 1 .214-.019c.369.108.525.079.428.003zm2.246 0c.393-.726.809-1.189 1.248-1.391-.605-1.896-.748-4.345-.393-7.363.037-.452.148-.646.322-.643.15.003.242.232.26.753-.111 1.661-.246 3.114-.172 4.347.068 1.102.328 2.017.615 3.048.039.143-.063.256-.563.535-.367.208-.6.464-.676.73a.319.319 0 0 0-.215-.019c-.369.108-.524.079-.426.003z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M26.703 18.242c.143.226.104.271.197.344.119.094.314.096.506.065.76-.118.654.339.318.854-.168.258-.561.517-.766.738-.203.222-.221.405-.303.46-.219.006-.439.008-.658.006-.219.002-.439 0-.658-.006-.082-.055-.098-.238-.303-.46-.205-.221-.594-.48-.764-.738-.337-.515-.443-.973.318-.854.189.029.387.028.507-.065.092-.072.056-.118.198-.344.08-.134.19-.248.322-.332.12-.074.25-.033.379-.033.131 0 .26-.041.381.033a.977.977 0 0 1 .326.332z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.883 20.729l-.127-.02c-.063-.516-.282-1-.629-1.387.385.26.672.817.756 1.407zm.232 0l.128-.019a2.54 2.54 0 0 1 .628-1.387c-.385.259-.671.816-.756 1.406z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M27.75 18.644c-.064.165-.139.346-.285.498-.225.232-.596.082-.955-.219-.113-.094-.313-.14-.513-.14-.199.001-.398.048-.508.14-.359.301-.732.451-.955.219-.146-.153-.219-.333-.287-.498.086-.016.2-.015.346.008.189.029.387.028.507-.065.092-.072.056-.118.198-.344.08-.134.19-.248.322-.332.12-.074.25-.033.379-.033.131 0 .26-.041.381.033.119.074.23.184.322.332.145.226.105.271.197.344.119.094.316.096.506.065.115-.022.23-.025.345-.008z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M22.551 20.986c.228-.142.271-.104.347-.198.093-.12.095-.317.065-.506-.119-.761.338-.655.854-.317.258.168.516.559.738.763.222.205.404.222.46.302.007.292.009.545.007.659.002.114 0 .367-.007.659-.056.081-.238.099-.46.302-.221.204-.48.595-.738.764-.516.336-.973.443-.854-.319.029-.188.027-.386-.065-.505-.074-.094-.118-.055-.347-.198a1.018 1.018 0 0 1-.332-.324c-.073-.12-.033-.25-.033-.38s-.041-.26.033-.38c.074-.119.185-.23.332-.322z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 21.804l-.02.128c-.516.062-1 .28-1.389.626.261-.381.818-.668 1.409-.754zm0-.23l-.02-.128c-.516-.063-1-.282-1.389-.628.261.384.818.67 1.409.756z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M22.954 19.937c.166.067.346.141.5.288.231.225.082.596-.22.955-.095.113-.14.313-.14.513s.048.398.14.508c.3.359.451.731.22.955-.154.147-.334.22-.5.287a1.057 1.057 0 0 1 .008-.346c.029-.188.028-.386-.064-.505-.074-.094-.118-.055-.346-.198a1.018 1.018 0 0 1-.332-.324c-.073-.12-.032-.25-.032-.38s-.041-.26.032-.38c.086-.132.199-.243.332-.324.228-.142.271-.104.346-.198.094-.12.096-.317.064-.506a1.08 1.08 0 0 1-.008-.345z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M29.447 22.392c-.229.143-.271.104-.346.198-.096.12-.096.317-.064.505.119.762-.34.655-.854.319-.258-.168-.518-.559-.738-.764-.223-.205-.404-.222-.461-.302-.006-.22-.008-.439-.006-.659-.002-.114-.002-.366.006-.658.057-.081.238-.098.461-.302s.48-.595.738-.763c.514-.337.973-.443.854.317-.029.189-.029.386.064.506.072.093.117.056.346.198.133.081.248.192.33.324.076.12.035.25.035.38s.041.259-.035.38a1.002 1.002 0 0 1-.33.321z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.959 21.574l.021-.128c.516-.063 1-.282 1.387-.628-.26.384-.818.67-1.408.756zm0 .23l.021.128c.516.061 1 .28 1.387.626-.26-.381-.818-.668-1.408-.754z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M29.045 23.441c-.166-.067-.348-.14-.498-.287-.232-.224-.084-.595.217-.955.096-.113.143-.314.141-.513 0-.2-.049-.399-.141-.508-.301-.359-.449-.73-.217-.955.15-.146.332-.219.498-.287.018.087.016.2-.01.346-.029.189-.027.386.066.506.072.093.117.056.344.198.135.081.248.192.332.324.074.12.035.25.035.38s.039.259-.035.38a.99.99 0 0 1-.332.324c-.227.143-.271.104-.344.198-.096.12-.098.317-.066.505a.971.971 0 0 1 .01.344z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 21.689,
    r: 1.122,
    fill: "#F4C027",
    strokeWidth: 0.175
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 21.689,
    r: 0.826,
    fill: "#F4C027",
    strokeWidth: 0.174
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 21.689,
    r: 0.52,
    fill: "#00498F",
    strokeWidth: 0.174
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.411 22.672l.098-.042c-.223-.31-.271-.606-.187-.903-.191.236-.144.606.089.945z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M15.633 18.875c.193.243.17.302.273.371.137.09.322.059.493-.007.706-.268.707.289.501.927-.1.309-.4.645-.533.907-.133.257-.104.451-.164.516-.191.032-.384.06-.576.083-.099.016-.315.043-.567.071-.082-.047-.146-.229-.379-.431-.234-.202-.64-.42-.857-.667-.442-.5-.677-.981.019-.964.174.004.346-.027.424-.151.061-.096.014-.14.074-.422.029-.16.096-.31.195-.439.088-.107.219-.084.338-.106.121-.022.231-.093.364-.025.136.067.268.179.395.337z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.532 21.688l-.115-.004c-.187-.527-.501-1-.916-1.375.41.228.807.781 1.031 1.379zm.199-.028a1.91 1.91 0 0 0 .107-.035 2.871 2.871 0 0 1 .223-1.568c-.284.343-.398.982-.33 1.603z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M16.73 19.172c-.026.205-.054.426-.156.622-.153.295-.534.182-.94-.102-.127-.089-.325-.109-.504-.078-.181.031-.347.114-.42.232-.23.381-.51.594-.77.377-.174-.144-.29-.33-.4-.501a.72.72 0 0 1 .305-.042c.173.004.345-.027.423-.151.062-.096.015-.14.073-.421.029-.16.097-.311.195-.44.088-.107.221-.084.34-.105.121-.021.23-.093.363-.026s.268.178.395.336c.193.243.168.302.273.372.137.089.322.058.493-.007a.907.907 0 0 1 .33-.066z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.182,
    d: "M12.877 21.94c.111-.136.158-.105.177-.191.026-.11-.039-.282-.125-.447-.339-.659.022-.603.51-.344.123.066.269.183.41.303.144.122.286.248.407.333.24.173.391.179.461.247.107.268.197.5.234.604.041.104.127.335.223.602-.014.075-.154.096-.258.286-.103.187-.183.527-.308.691-.185.24-.353.383-.481.359-.129-.023-.224-.212-.258-.631a.742.742 0 0 0-.215-.437c-.084-.08-.104-.046-.311-.162a1.33 1.33 0 0 1-.342-.269c-.09-.1-.104-.212-.146-.324-.042-.111-.113-.22-.104-.327a.556.556 0 0 1 .126-.293z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.018 22.653c.01.046.021.091.033.136a1.265 1.265 0 0 0-.881.704.941.941 0 0 1 .281-.526c.159-.151.354-.259.567-.314zm-.086-.241l-.063-.134a2.197 2.197 0 0 1-.68-.173 3.13 3.13 0 0 1-.646-.386c.17.188.388.347.627.466.245.118.508.198.762.227z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M12.818 20.876c.146.052.241.118.408.254a.663.663 0 0 1 .221.425c.024.172.005.367-.042.561-.029.12.008.323.077.524.071.201.177.398.284.505.355.353.605.725.505.958a.477.477 0 0 1-.216.258c-.042-.086-.145-.164-.178-.31-.043-.189-.115-.385-.228-.502-.087-.092-.106-.195-.323-.329-.14-.087-.258-.049-.353-.166-.185-.226-.427-.774-.19-1.026.233-.248.316-.387.119-.813-.066-.145-.064-.252-.084-.339z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.181,
    d: "M19.02 22.667c-.186.158-.232.127-.284.222-.065.122-.034.307.022.481.223.685-.198.625-.703.363-.251-.131-.545-.463-.772-.631-.229-.167-.39-.165-.452-.235-.05-.204-.096-.41-.138-.616v-.001a16.99 16.99 0 0 1-.129-.635c.03-.084.188-.124.344-.354.158-.233.314-.668.519-.88.416-.434.838-.62.859.213.006.203.043.407.15.517.085.086.121.042.357.159.155.076.28.175.369.289.09.113.071.25.092.379.02.129.078.254.024.381a.897.897 0 0 1-.258.348z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16.672 22.144l-.01-.125c.465-.127.825-.393 1.12-.784-.164.418-.612.762-1.11.909zm.045.218l.043.119c.486.009.924.169 1.332.453-.297-.337-.842-.552-1.375-.572z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.176,
    d: "M18.819 23.687c-.158-.048-.33-.099-.488-.221-.242-.185-.172-.544.037-.915.066-.119.073-.319.04-.514-.034-.197-.112-.39-.217-.488-.341-.327-.548-.686-.375-.949.115-.176.272-.279.417-.375.031.091.051.212.055.368.006.203.041.407.149.517.085.086.121.042.358.159.154.076.279.175.367.289.09.113.071.25.092.379.02.129.078.254.024.381a.918.918 0 0 1-.26.35c-.185.158-.231.126-.284.222-.064.122-.035.307.021.481a.92.92 0 0 1 .064.316z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    d: "M15.606 21.259c.584-.029 1.148.479 1.232 1.101.082.621-.328 1.104-.887 1.109-.562.007-1.082-.449-1.188-1.048-.107-.6.257-1.134.843-1.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    d: "M15.654 21.564c.427-.02.837.349.9.803.063.454-.23.814-.647.821-.41.006-.801-.337-.877-.776-.078-.447.196-.829.624-.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00498F",
    d: "M15.702 21.874c.266-.01.521.217.563.502.041.285-.144.514-.406.52-.26.005-.507-.211-.554-.491-.047-.281.13-.522.397-.531z"
  }))), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.201,
    cy: 18.395,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.076,
    cy: 20.266,
    r: 0.858,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.896,
    cy: 18.698,
    r: 0.858,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.668,
    cy: 17.111,
    r: 0.858,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M31.498 19.198c-.494-.033-.371.85-.271 1.046.127.257.246.265.404.028.123-.183.363-1.041-.133-1.074z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 0.174,
    d: "M31.467 19.675c-1.168-.079-.879 1.995-.646 2.458.301.604.578.623.959.065.286-.427.851-2.445-.313-2.523z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M40.869 20.446c-.475-.15-.564.736-.518.95.063.279.178.316.391.124.16-.148.598-.924.127-1.074z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 0.174,
    d: "M40.723 20.901c-1.113-.354-1.328 1.729-1.215 2.232.148.658.414.742.916.292.383-.345 1.41-2.169.299-2.524z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M28.605 9.921c2.502-.225 5.061.029 7.592 1.034 2.135.848 1.926 3.322-.678 6.757.234.435.371.976.391 1.601-.275-.015-.469-.008-.713-.014.189-.416-.021-.926-.26-1.286-.156-.234-.188-.193 0-.455 1.549-2.161 2.576-4.052 1.973-5.195-.734-1.389-3.58-2.112-8.381-2.006l.025-.384.051-.052z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.744,
    cy: 11.517,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.996,
    cy: 10.946,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M38.764 10.814l-.266.354c1.408.772 1.99 1.587 1.854 2.407-.021.141-.449 1.641-1.408 4.547-.654.452-1.143.856-1.461 1.211.035.042-.104.167-.064.202-.096.443.404.353.74.244.162-.427.656-.88.939-1.073.059-.04.266-.142.287-.208.514-1.635 1.025-3.146 1.467-4.555.443-1.415-.516-2.419-2.088-3.129z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M44.322 21.319l.053.286c.41.095.764.119 1.053.072-.487-.477-.85-.578-1.106-.358z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.177,
    d: "M44.365 20.666c-.256.057-.279.1-.391.12-.145.024-.344.014-.48-.104-.555-.335-.568.268-.352.718.156.327.074.696-.072.975-.178.331-.141.481-.016.571l.242.156c.15.177.266.147.285-.084.559-.229.74-.763.908-1.233.243-.687 1.13-.85-.124-1.119z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.194,
    d: "M44.148 20.69c-.484.172-.541-.097-.867-.082.131.74.26 1.124 1.035.726.426-.219.971.103 1.076.341.037.086.287-.093.377-.292.379-.831-.974-.925-1.621-.693z"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.383,
    cy: 8.894,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.201,
    cy: 8.894,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.02,
    cy: 9.036,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.695,
    cy: 9.357,
    r: 0.888,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.723,
    cy: 13.933,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.195,
    cy: 12.97,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.457,
    cy: 12.156,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.904,
    cy: 15.383,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M42.145 24.277c-.352-.107-.898.668-1.029.655-.172-.443.18-1.503.803-2.343.424-.138.461-.41.551-1.042.025-.189.391-.059.396.263.006.344.033.535-.043.829-.029.117-.016.227.115.333-.663.26-.825.582-.793 1.305z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.178,
    d: "M42.459 21.554c.063.146.08.265.096.486a.7.7 0 0 1-.158.466 1.49 1.49 0 0 1-.438.363c-.107.062-.23.234-.328.43-.1.194-.17.414-.174.57-.014.516-.115.967-.352 1.056a.455.455 0 0 1-.334.021c.031-.093.02-.223.104-.353.105-.167.201-.358.209-.525.008-.131.068-.218.02-.475-.031-.166-.143-.229-.123-.383.039-.297.271-.867.617-.867.342 0 .5-.037.676-.486.056-.152.134-.226.185-.303z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M43.74 22.791a1.277 1.277 0 0 0-.309-.165.853.853 0 0 0-.555-.025c-.814.245-1.172 1.681-.277 2.027.176.021.338-.137.496-.483.186-.459.385-.777.596-.972.131-.162.135-.299.049-.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.175,
    d: "M43.33 22.886c-.783-.303-1.359 1.186-.629 1.468.393.152.43-.336.508-.607.102-.366.871-.57.121-.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00498F",
    strokeWidth: 0.174,
    d: "M43.246 23.106c-.381-.146-.904.74-.428.942.324.137.578-.042.68-.31.106-.268.018-.528-.252-.632z"
  }))), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.914,
    cy: 16.881,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.588,
    cy: 15.346,
    r: 0.925,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.377,
    cy: 9.902,
    r: 0.892,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.873,
    cy: 10.615,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.977,
    cy: 11.922,
    r: 0.925,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.154,
    cy: 13.567,
    r: 0.924,
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M43.588 22.672l-.1-.042c.225-.31.271-.606.188-.903.189.236.146.606-.088.945z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M36.365 18.875c-.191.243-.17.302-.273.371-.137.09-.32.059-.492-.007-.707-.268-.707.289-.502.927.1.309.398.645.533.907.133.257.105.451.162.516.256.041.479.072.576.083.1.016.316.043.568.071.082-.047.145-.229.379-.431s.639-.42.855-.667c.443-.5.68-.981-.018-.964-.174.004-.346-.027-.424-.151-.063-.096-.018-.14-.076-.422a.988.988 0 0 0-.193-.439c-.09-.107-.219-.084-.34-.106s-.229-.093-.363-.025a1.243 1.243 0 0 0-.392.337z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M36.467 21.688l.115-.004c.188-.527.5-.999.914-1.375-.408.228-.807.781-1.029 1.379zm-.199-.028l-.107-.035a2.882 2.882 0 0 0-.223-1.568c.285.343.398.982.33 1.603z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M35.27 19.172c.025.205.053.426.154.622.152.295.533.182.941-.102.129-.089.322-.109.504-.078s.348.114.418.232c.232.381.512.594.771.377.174-.144.291-.33.4-.501a.753.753 0 0 0-.305-.042c-.174.004-.346-.027-.424-.151-.063-.096-.018-.14-.076-.421a.991.991 0 0 0-.193-.44c-.09-.107-.219-.084-.34-.105s-.229-.093-.363-.026a1.222 1.222 0 0 0-.393.336c-.193.243-.17.302-.275.372-.137.089-.32.058-.492-.007a.904.904 0 0 0-.327-.066z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.182,
    d: "M39.123 21.94c-.113-.136-.158-.105-.18-.191-.025-.11.039-.282.123-.447.342-.659-.021-.603-.508-.344a2.713 2.713 0 0 0-.412.303c-.143.122-.285.248-.404.333-.242.173-.393.179-.463.247-.107.268-.195.5-.232.604h-.002c-.076.2-.15.4-.223.602.016.075.152.096.258.286.104.187.186.527.311.691.184.24.35.383.48.359.129-.023.223-.212.258-.631a.736.736 0 0 1 .215-.437c.086-.08.104-.046.313-.162.135-.075.248-.168.34-.269.092-.1.107-.212.148-.324.041-.111.111-.22.102-.327a.574.574 0 0 0-.124-.293z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M36.98 22.653l-.031.136a1.264 1.264 0 0 1 .879.704.944.944 0 0 0-.279-.526 1.304 1.304 0 0 0-.569-.314zm.086-.241l.063-.134a2.15 2.15 0 0 0 .68-.173 3.09 3.09 0 0 0 .646-.386 2.094 2.094 0 0 1-.627.466c-.24.118-.496.195-.762.227z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M39.18 20.876c-.145.052-.24.118-.406.254a.658.658 0 0 0-.221.425c-.023.172-.006.367.043.561.029.12-.008.323-.078.524s-.178.398-.283.505c-.355.353-.604.725-.506.958a.48.48 0 0 0 .217.258c.041-.086.143-.164.176-.31.045-.189.117-.385.23-.502.086-.092.104-.195.32-.329.141-.087.26-.049.354-.166.186-.226.426-.774.189-1.026-.23-.248-.316-.387-.121-.813.068-.145.066-.252.086-.339z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.181,
    d: "M32.979 22.667c.184.158.232.127.283.222.066.122.035.307-.021.481-.223.685.199.625.703.363.252-.131.547-.463.773-.631s.391-.165.451-.235c.064-.271.115-.508.139-.616v-.001c.023-.107.074-.35.129-.635-.031-.084-.188-.124-.346-.354-.154-.233-.313-.668-.518-.88-.418-.434-.838-.62-.859.213-.006.203-.043.407-.148.517-.088.086-.121.042-.359.159-.143.067-.27.166-.367.289-.092.113-.07.25-.092.379-.02.129-.078.254-.023.381a.852.852 0 0 0 .255.348z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M35.328 22.144l.01-.125c-.465-.127-.828-.393-1.123-.784.166.418.611.762 1.113.909zm-.047.218l-.043.119c-.488.009-.924.169-1.334.453.299-.337.846-.552 1.377-.572z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.176,
    d: "M33.18 23.687c.158-.048.33-.099.488-.221.24-.185.17-.544-.037-.915-.064-.119-.072-.319-.039-.514.035-.197.113-.39.217-.488.34-.327.551-.686.377-.949-.117-.176-.273-.279-.416-.375a1.31 1.31 0 0 0-.059.368c-.004.203-.041.407-.148.517-.086.086-.121.042-.359.159a1.035 1.035 0 0 0-.367.289c-.088.113-.068.25-.09.379-.02.129-.078.254-.023.381a.914.914 0 0 0 .258.35c.186.158.23.126.283.222.064.122.035.307-.021.481a.977.977 0 0 0-.064.316z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    d: "M36.395 21.259c-.586-.029-1.148.479-1.232 1.101-.082.622.326 1.104.885 1.109.563.007 1.082-.449 1.189-1.048.105-.6-.26-1.134-.842-1.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    d: "M36.346 21.564c-.428-.02-.84.349-.9.803-.063.454.229.814.646.821.41.006.801-.337.877-.776.076-.447-.198-.829-.623-.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00498F",
    d: "M36.297 21.874c-.268-.01-.521.217-.563.502-.043.285.141.514.404.52.262.005.508-.211.555-.491.045-.281-.129-.522-.396-.531z"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M39.764 32.374c.289.043.443.225.434.411.01.186-.145.369-.434.413a1.411 1.411 0 0 1-.225.039c-9.012.755-18.069.755-27.08 0a1.222 1.222 0 0 1-.224-.039c-.292-.043-.444-.226-.437-.413-.01-.186.145-.369.436-.411.066-.019.141-.032.223-.039a162.19 162.19 0 0 1 27.082 0c.082.007.156.02.225.039z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.181,
    d: "M15.84 32.956a161.07 161.07 0 0 1 13.546-.273c2.258.048 4.516.142 6.771.28m-20.317.019c1.127.071 2.256.129 3.384.175m13.551-.007c1.127-.046 2.256-.105 3.383-.174"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#D93A43",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.349,
    d: "M1.237 33.367V73.39c0 7.162 2.781 13.666 7.268 18.377C12.989 96.48 19.18 99.4 26 99.4c6.818 0 13.007-2.922 17.494-7.633 4.486-4.713 7.27-11.217 7.27-18.379V33.367H1.237z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.175,
    d: "M26.225 97.332c.215-.035.576.01.851-.206.367-.286.221-1.442.188-2.177-.168-3.739-.32-10.035-.512-18.877a2.439 2.439 0 0 0-.753.012 2.431 2.431 0 0 0-.752-.012c-.19 8.842-.345 15.138-.512 18.877-.033.732-.178 1.891.188 2.177.273.216.637.171.853.206h.449z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.57 97.225c-.219-.017-.574.063-.867-.127-.391-.252-.422-1.437-.455-2.168-.174-3.74-.52-10.006-1.13-18.828.246-.058.5-.076.751-.059l.102-.021c1.41 8.728 1.941 14.92 2.904 18.653.133.515.418 1.808-.025 2.228-.256.24-.619.228-.83.281l-.45.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.328 96.83c-.219.004-.568.113-.875-.048-.412-.218-.396-1.398-.58-2.107-.963-3.735-1.496-9.929-2.904-18.659.301-.1.529-.117.744-.125l.031-.01c2.236 8.486 2.91 14.469 4.646 18.164.16.514.6 1.872.18 2.348-.23.262-.596.281-.801.354l-.441.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.104 96.047c-.217.025-.582.229-.906.096-.43-.174-.496-1.438-.805-2.097-1.746-3.712-2.416-9.731-4.682-18.28.289-.127.516-.17.729-.197.195-.09.158-.137.471-.184 2.631 8.444 3.484 14.317 5.967 17.963.4.588.693 1.767.422 2.144-.203.282-.564.34-.762.433l-.434.122z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M23.428 97.225c.218-.017.574.063.867-.127.39-.252.42-1.437.455-2.168.172-3.74.519-10.006 1.129-18.828a2.569 2.569 0 0 0-.752-.059l-.102-.021c-1.406 8.728-1.939 14.92-2.902 18.653-.134.515-.42 1.808.024 2.228.254.24.619.228.831.281l.45.041z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M20.672 96.83c.218.004.566.113.875-.048.41-.218.394-1.398.576-2.107.965-3.735 1.496-9.929 2.904-18.659a2.431 2.431 0 0 0-.742-.125l-.029-.01c-2.238 8.486-2.912 14.469-4.648 18.164-.161.514-.598 1.872-.18 2.348.23.262.597.281.801.354l.443.083z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M17.897 96.047c.216.025.582.229.904.096.431-.174.498-1.438.807-2.097 1.745-3.712 2.416-9.731 4.68-18.28a2.39 2.39 0 0 0-.728-.197c-.197-.09-.159-.137-.472-.184-2.629 8.444-3.484 14.317-5.965 17.963-.4.588-.692 1.767-.42 2.144.203.282.565.34.762.433l.432.122z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.176,
    d: "M32.633 89.668c-.195.012-.494.133-.807-.016-.412-.197-.684-1.338-.904-2.047-1.76-3.472-3.367-9.639-6.005-18.211a1.96 1.96 0 0 1 .656-.147 1.94 1.94 0 0 1 .646-.171c2.839 8.48 4.115 14.615 6.888 17.992.461.557.801 1.772.584 2.125-.166.266-.494.299-.668.379l-.39.096z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.175,
    d: "M30.391 90.107c-.199-.004-.512.094-.805-.078-.389-.229-.523-1.387-.664-2.11-.711-3.694-2.02-9.897-3.878-18.604.268-.086.474-.098.67-.097.182-.063.377-.116.664-.118 2.197 8.651 2.707 15.131 4.785 18.457.379.605.59 1.828.334 2.164-.195.248-.527.258-.711.323l-.395.063z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.175,
    d: "M28.104 90.368c-.197-.021-.52.052-.789-.144-.361-.261-.365-1.423-.422-2.154-.277-3.733-.867-10.014-1.713-18.827a2.1 2.1 0 0 1 .677-.043c.188-.048.389-.085.673-.064 1.189 8.788 1.883 15.151 2.637 18.755.148.719.377 1.868.082 2.18-.223.234-.553.216-.742.267l-.403.03z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.176,
    d: "M19.364 89.668c.198.012.496.133.809-.016.412-.197.683-1.338.904-2.047 1.76-3.472 3.367-9.639 6.003-18.211a1.973 1.973 0 0 0-.656-.147 1.926 1.926 0 0 0-.646-.171c-2.84 8.48-4.114 14.615-6.891 17.992-.458.557-.8 1.772-.581 2.125.165.266.492.299.667.379l.391.096z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.175,
    d: "M21.61 90.107c.198-.004.51.094.801-.078.389-.229.526-1.387.666-2.11.709-3.694 2.018-9.897 3.876-18.604a1.961 1.961 0 0 0-.667-.097 1.956 1.956 0 0 0-.664-.118c-2.197 8.651-2.705 15.131-4.785 18.457-.379.605-.59 1.828-.332 2.164.192.248.524.258.707.323l.398.063z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.175,
    d: "M23.896 90.368c.196-.021.519.052.79-.144.359-.261.363-1.423.419-2.154.28-3.733.868-10.014 1.715-18.827a2.049 2.049 0 0 0-.676-.043 1.9 1.9 0 0 0-.675-.064c-1.19 8.788-1.883 15.151-2.635 18.755-.15.719-.379 1.868-.084 2.18.223.234.554.216.744.267l.402.03z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.174,
    d: "M26.202 90.443c.194-.035.523.012.767-.205.332-.286.201-1.443.17-2.176-.148-3.74-.287-10.035-.461-18.879a1.985 1.985 0 0 0-.679.012 2.085 2.085 0 0 0-.678-.012c-.171 8.842-.311 15.139-.462 18.879-.028.731-.161 1.89.168 2.176.247.217.575.17.769.205h.406z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.082 84.523c-.15.014-.381.134-.619-.015-.314-.196-.521-1.338-.691-2.047-1.35-3.473-2.58-9.64-4.601-18.211.156-.085.326-.136.502-.147.134-.076.277-.146.496-.172 2.173 8.48 3.152 14.614 5.277 17.991.35.558.611 1.774.445 2.127-.125.265-.381.3-.514.38l-.295.094z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.361 84.966c-.152-.004-.389.093-.613-.081-.299-.228-.402-1.385-.51-2.107-.545-3.696-1.547-9.898-2.971-18.605a1.22 1.22 0 0 1 .513-.096c.158-.077.333-.117.51-.119 1.681 8.65 2.072 15.131 3.666 18.458.289.606.451 1.829.254 2.162-.146.251-.402.259-.541.323l-.308.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.609 85.227c-.148-.021-.396.051-.604-.146-.275-.259-.279-1.42-.32-2.151-.216-3.734-.666-10.014-1.314-18.828.211-.063.368-.062.519-.043.144-.048.298-.086.516-.063.913 8.788 1.442 15.149 2.018 18.753.117.719.289 1.868.064 2.182-.17.233-.426.215-.57.266l-.309.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.917 84.523c.152.014.381.134.619-.015.316-.196.523-1.338.693-2.047 1.35-3.473 2.58-9.64 4.599-18.211a1.196 1.196 0 0 0-.501-.147 1.255 1.255 0 0 0-.496-.172c-2.174 8.48-3.151 14.614-5.276 17.991-.351.558-.612 1.774-.444 2.127.125.265.377.3.51.38l.296.094z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.637 84.966c.152-.004.391.093.613-.081.299-.228.403-1.385.51-2.107.544-3.696 1.546-9.898 2.972-18.605a1.204 1.204 0 0 0-.513-.096 1.2 1.2 0 0 0-.51-.119c-1.683 8.65-2.071 15.131-3.664 18.458-.291.606-.453 1.829-.256 2.162.147.251.402.259.541.323l.307.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.388 85.227c.151-.021.397.051.604-.146.276-.259.278-1.42.32-2.151.215-3.734.666-10.014 1.314-18.828a1.184 1.184 0 0 0-.519-.043 1.14 1.14 0 0 0-.518-.063c-.911 8.788-1.44 15.149-2.018 18.753-.115.719-.289 1.868-.063 2.182.169.233.423.215.568.266l.312.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.153 85.301c.15-.035.4.01.589-.205.254-.287.152-1.445.129-2.177-.115-3.739-.223-10.035-.352-18.879a1.19 1.19 0 0 0-.521.013 1.232 1.232 0 0 0-.52-.013c-.132 8.843-.238 15.14-.354 18.879-.022.731-.123 1.89.129 2.177.189.215.439.17.588.205h.312z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeLinejoin: "round",
    strokeWidth: 0.179,
    d: "M15.652 75.166c-.473.021-1.053.291-2.75 1.76-.739 1.512-1.485 3.029-2.515 4.34-.35.23-.625.395-.904.483-.291.097-2.428.026-2.48-.063-.666-.603-1.683-.172-1.342.465-.265.25.316 1.164.782.783.429-.348 1.919-.02 2.417-.199-.188.447-1.535.738-2.477.808-.86.037-.803.896-.449 1.554.404.256.072-.068.219.119.385.569 1.209.496 1.236-.063.029-.578 2.037-1.329 2.339-1.772-.369.877-1.218 1.694-1.64 2.554-.453.457-.729.547-.145 1.463.651-.074.688-.248 1.087.131.89-.098 1.032-.36.89-1.063-.153-.743.47-2.086.676-2.466.191-.352.236-.714.423-.934.321-.381 1.856-1.145 2.25-.935.726.388 1.276.153 1.368-.548-.233-.18-.059-1.175-.561-1.217-.41-.035-.65.092-1.027.396-.592.485-.897.743-1.092.688-.461-.127.838-.764 2.02-2.313 1.639-2.146 1.752-3.237 1.675-3.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.176,
    d: "M5.758 82.543c-.592-.348-.935-.334-1.164-.074-.127.143-.287.066-.192-.154.394-.933 1.022-1.047 1.586-.61.159.146.286.271.413.397-.094.138-.567.336-.643.441zm8.492-.832c.629-.429 1.219-.512 1.541-.271.178.134.354.037.197-.183-.654-.918-1.417-.963-1.996-.444-.156.168-.279.313-.404.457.198.214.635.46.662.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.174,
    d: "M9.292 86.971c-.386.762-.59 1.285-.422 1.695.098.238-.013.459-.255.251-.983-.843-.985-1.812-.356-2.468.211-.221.434-.359.634-.521.255.24.419 1.006.399 1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.202,
    d: "M6.836 84.962c-.584.242-.787.55-.766.952.012.223-.134.307-.217.048-.714-1.659.027-1.969 1.1-1.909.061.29-.091.897-.117.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.174,
    d: "M11.872 81.27c-.386-.226-.41-.473-.308-.641.212-.354.429-.184.831.145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.174,
    d: "M12.37 80.727c-.385-.223-.408-.471-.307-.638.214-.354.43-.185.832.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.194,
    d: "M12.929 80.213c-.425-.292-.45-.613-.339-.832.236-.46.474-.238.918.186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.202,
    d: "M13.533 79.566c-.45-.33-.478-.694-.36-.939.25-.52.502-.27.976.211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.209,
    d: "M14.168 78.879c-.42-.348-.551-.693-.359-.999.3-.474.502-.286.975.226"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M19.856 41.57c-.301.263-1.294.267-2.654.354-2.188.077-3.457-.583-3.738-1.983.82.978 1.801 1.461 2.914 1.187 1.502-.372 2.36-.638 2.705-.572.231.081.567.497.773 1.014z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.924 71.419c-.012.685-.02 1.369-.022 2.054l-.007.002-1.564.325c-.004.714 1.76 8.177 2.668 8.177.91 0 2.673-7.47 2.669-8.181l-1.564-.321-.008-.002c-.004-.685-.012-1.369-.021-2.054-.33.272-.693.75-1.074 1.179-.383-.431-.747-.907-1.077-1.179z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M23.113 74.588l-1.401-.794c-.59.423-1.026 1.993-.019 3.276 1.256 1.6 1.765 2.76 2.072 4.054.914-1.169 1.229-2.399.647-3.601-.783-1.619-1.29-2.532-1.299-2.935z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M24.258 73.467l-1.402-.793c-.589.424-1.822 1.944-.814 3.227 1.256 1.601 2.563 2.812 2.869 4.105.916-1.17 1.305-2.4.725-3.602-.785-1.618-1.37-2.532-1.378-2.937zm4.627 1.121l1.4-.794c.592.423 1.027 1.993.021 3.276-1.258 1.6-1.766 2.76-2.07 4.054-.916-1.169-1.23-2.399-.65-3.601.781-1.619 1.291-2.532 1.299-2.935z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M27.742 73.467l1.4-.793c.59.424 1.822 1.944.814 3.227-1.256 1.601-2.563 2.812-2.871 4.105-.914-1.17-1.303-2.4-.721-3.602.784-1.618 1.37-2.532 1.378-2.937zm-6.577-.569l-1.402-.793c-.592.424-1.027 1.994-.02 3.277 1.258 1.6 1.766 2.76 2.072 4.055.914-1.17 1.229-2.4.648-3.602-.782-1.616-1.293-2.528-1.298-2.937z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M30.834 72.898l1.402-.793c.59.424 1.027 1.994.02 3.277-1.256 1.6-1.766 2.76-2.072 4.055-.914-1.17-1.229-2.4-.648-3.602.782-1.616 1.29-2.528 1.298-2.937z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M14.67 58.123c.026 1.279-.201 9.818-.271 11.023-.07 1.201-.604 2.021-1.173 2.489-.521-.716-.832-1.68-.907-2.825-.037-.586.07-8.664.115-10.324.958-2.53 1.669-2.627 2.236-.363z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M9.112 56.035l-.363 11.738c-.113 1.043 1.244 7.24 1.988 8.463 1.836-.785 2.225-4.989 1.879-9.086-.346-4.096.059-7.635.338-8.371.024-.926-.131-1.894-.141-2.857-1.17.067-2.532.042-3.701.113z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M6.935 57.955l.249 11.743c-.061 1.047 1.621 7.159 2.426 8.341 1.863-1.443 1.488-7.348 1.203-9.133-.57-3.561-.473-7.684-.275-8.352-.023-.928-.048-2.037-.107-3-1.166.134-2.331.266-3.496.401z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M5.318 60.734l3.09-.077c-.263 1.28-.054 5.26.48 8.293.5 2.844 1.198 10.217-1.767 11.987-1.839-3.89-.438-7.672-1.367-11.052-.722-3.589-.864-6.588-.436-9.151zm11.813-4.766c-.012 1.281-.498 9.808-.605 11.013-.107 1.197-.667 1.998-1.248 2.451-.499-.732-.781-1.707-.82-2.854-.02-.584.334-8.657.428-10.313 1.032-2.503 1.747-2.577 2.245-.297z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M11.642 49.012c-.082 2.75-.13 8.718-.112 9.227.04 1.146.492 2.606.991 3.34.583-.452 1.14-1.253 1.248-2.452.089-.986.12-5.822.135-8.248a10.362 10.362 0 0 1-1.784-1.435c0-.002-.457-.408-.478-.432z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M13.849 50.786c-.037 2.67-.04 5.34-.009 8.01.039 1.147.32 2.122.82 2.853.582-.449 1.196-1.279 1.305-2.479.065-.738.271-3.9.291-6.329-.783-.245-1.772-1.528-2.407-2.055z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M11.95 48.766l-2.104-3.028c-.426 1.493-.943 12.207-.334 13.088a5.384 5.384 0 0 0 .953 2.85c.584-.451 1.453-1.263 1.201-2.477-.251-1.215.03-9.183.284-10.433z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M7.635 55.504c-.096 1.66-.163 2.781-.143 3.367.039 1.146.32 2.12.819 2.854.582-.451 1.323-1.25 1.248-2.451-.294-4.641.214-9.013.808-13.213-.5-.366-1.342-.761-1.841-1.126-.998 5.656-1.33 9.169-.891 10.569z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M5.532 58.542l.571 2.157c.039 1.146.749 2.095 1.248 2.826.583-.452 1.112-1.194.964-2.389-.854-6.854-.549-11.389.891-16.973-3.258 2.221-4.768 6.903-3.674 14.379z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M5.699 60.663l-2.989-.989c-.38 2.982.205 6.729 1.01 11.669.691 4.243.328 7.601-.2 9.753 3.187-.435 4.536-4.539 2.937-12.257-.417-2.021-.839-4.601-.758-8.176z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M5.606 75.1c.07-1.977-.262-4.134-.637-5.951a37.016 37.016 0 0 1-.799-7.391"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.178,
    d: "M5.579 43.116l1.961.33c-.097.42-.595 2.997-.685 3.436-.733 3.582-1.216 7.8-.662 12.427.206 1.719.57 3.123 1.104 4.207-2.151-.244-3.529-2.342-3.352-6-.373-4.271-.208-7.668.483-10.225.205-.748.858-3.57 1.151-4.175z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.178,
    d: "M4.391 43.579l.963 1.098c-.273.195.189 1.036-.059 2.67-.162.927-.715 2.022-.83 3.205-.379 3.925-.379 8.837.801 11.976-2.152-.243-2.891-2.189-2.96-5.853-.058-3.027-.067-6.596.694-10.717.155-.964.618-1.732 1.391-2.379z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.181,
    d: "M9.764 46.467l-1.985-.23c-.364 1.874-.644 3.199-.711 3.867-.133 1.31.265 2.51.72 3.403.731-.438 1.071-1.403 1.379-2.752.309-1.357.387-2.833.597-4.288z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M14.918 50.688l-1.763.02c-.062 1.616-.104 2.71-.075 3.281.057 1.117.336 2.063.813 2.771.536-.446 1.042-1.231 1.123-2.399.08-1.177-.088-2.427-.098-3.673z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M16.814 51.521l-1.76.08c-.005 1.619-.009 2.713.04 3.28.096 1.115.408 2.052.908 2.742.52-.464 1-1.267 1.039-2.438.038-1.173-.171-2.415-.227-3.664zm-3.692-1.742l-1.758-.124c-.189 1.606-.324 2.693-.342 3.263-.034 1.119.168 2.085.587 2.828.57-.398 1.138-1.143 1.313-2.301.175-1.163.109-2.424.2-3.666z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M11.475 47.884l-1.928-.799c-.33 1.301-.773 5.586.017 7.396.642-.436 1.291-1.252 1.506-2.541.216-1.294.281-2.671.405-4.056z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M8.926 45.76l-3.082.273c-.709 1.765-1.174 3.33-1.398 4.748 1.43-.254 2.465-.953 2.835-2.232.501-1.727 1.384-2.485 1.645-2.789z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.137,
    d: "M12.049 92.371c1.177.941 2.254-1.211 1.211-4.057-.772-2.106-4.547-1.291-2.445 1.543.1.135.24.072.221-.082-.119-.58.252-.918.824-.812 1.563.292 1.613 3.257-.087 2.582-.312-.02-.033.578.276.826zm3.864 0c-1.177.941-2.254-1.211-1.209-4.057.772-2.106 4.547-1.291 2.443 1.543-.102.135-.24.072-.221-.082.119-.58-.252-.918-.824-.812-1.563.292-1.612 3.257.087 2.582.311-.02.033.578-.276.826z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.198,
    d: "M13.866 83.225l-.001.021c-.151.494-.724 1.111-1.169 1.574-.689.718-.527 1.807-.049 2.385.521.632.752 1.341.857 1.895.078.34.218 1.102.115 2.286-.05.585-.404.884-.734 1.146-.168.134.072.45.628.866.061.047.228.16.308.449.03.069.289.069.319 0 .081-.289.248-.402.308-.449.557-.416.795-.732.627-.866-.33-.263-.684-.562-.734-1.146-.102-1.186.039-1.946.117-2.286.104-.554.336-1.263.856-1.895.478-.578.64-1.665-.05-2.385-.444-.463-1.018-1.08-1.17-1.574v-.021c-.008-.096-.062-.143-.114-.143-.054-.002-.106.047-.114.143z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.174,
    d: "M13.129 90.057h1.701c.293 0 .532.234.532.521a.528.528 0 0 1-.532.521h-1.701a.528.528 0 0 1-.532-.521.529.529 0 0 1 .532-.521z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.137,
    d: "M36.086 92.371c1.178.941 2.254-1.211 1.209-4.057-.771-2.106-4.547-1.291-2.441 1.543.098.135.236.072.219-.082-.119-.58.254-.918.824-.812 1.563.292 1.613 3.257-.088 2.582-.311-.02-.032.578.277.826zm3.863 0c-1.176.941-2.254-1.211-1.209-4.057.773-2.106 4.545-1.291 2.443 1.543-.1.135-.24.072-.223-.082.121-.58-.25-.918-.822-.812-1.564.292-1.611 3.257.088 2.582.311-.02.032.578-.277.826z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.198,
    d: "M37.904 83.225l-.002.021c-.152.494-.723 1.111-1.17 1.574-.688.718-.525 1.807-.047 2.385.52.632.752 1.341.855 1.895.078.34.219 1.102.115 2.286-.051.585-.402.884-.734 1.146-.168.134.072.45.629.866.061.047.227.16.309.449.029.069.289.069.318 0 .08-.289.248-.402.309-.449.555-.416.795-.732.627-.866-.33-.263-.684-.562-.732-1.146-.104-1.186.037-1.946.113-2.286.105-.554.338-1.263.859-1.895.477-.578.639-1.665-.051-2.385-.443-.463-1.018-1.08-1.17-1.574v-.021c-.008-.096-.063-.143-.115-.143-.054-.002-.105.047-.113.143z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.174,
    d: "M37.168 90.057h1.701c.293 0 .533.234.533.521a.528.528 0 0 1-.533.521h-1.701a.528.528 0 0 1-.533-.521.528.528 0 0 1 .533-.521z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M37.328 58.123c-.025 1.279.201 9.818.271 11.023.07 1.201.604 2.021 1.174 2.489.52-.716.832-1.68.904-2.825.039-.586-.068-8.664-.113-10.324-.957-2.53-1.668-2.627-2.236-.363z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M42.887 56.035l.361 11.738c.113 1.043-1.244 7.24-1.984 8.463-1.84-.785-2.227-4.989-1.883-9.086.348-4.096-.057-7.635-.336-8.371-.023-.926.131-1.894.141-2.857 1.169.067 2.529.042 3.701.113z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M45.064 57.955l-.25 11.743c.061 1.047-1.621 7.159-2.426 8.341-1.863-1.443-1.488-7.348-1.203-9.133.568-3.561.473-7.684.275-8.352.023-.928.049-2.037.107-3 1.167.134 2.333.266 3.497.401z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M46.68 60.734l-3.09-.077c.264 1.28.053 5.26-.479 8.293-.5 2.844-1.199 10.217 1.766 11.987 1.84-3.89.439-7.672 1.365-11.052.723-3.589.865-6.588.438-9.151zm-11.813-4.766c.012 1.281.498 9.808.605 11.013.105 1.197.666 1.998 1.248 2.451.498-.732.781-1.707.818-2.854.021-.584-.332-8.657-.428-10.313-1.032-2.503-1.745-2.577-2.243-.297z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M40.357 49.012c.082 2.75.129 8.718.111 9.227-.039 1.146-.492 2.606-.992 3.34-.582-.452-1.141-1.253-1.248-2.452-.088-.986-.119-5.822-.135-8.248a10.355 10.355 0 0 0 1.783-1.435c.003-.002.462-.408.481-.432z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M38.148 50.786c.055 2.963.021 7.631.012 8.01-.041 1.147-.322 2.122-.822 2.853-.582-.449-1.195-1.279-1.305-2.479-.064-.738-.27-3.9-.291-6.329.783-.245 1.772-1.528 2.406-2.055z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M40.049 48.766l2.104-3.028c.426 1.493.943 12.208.336 13.088a5.421 5.421 0 0 1-.953 2.85c-.584-.451-1.453-1.263-1.201-2.477.249-1.215-.032-9.183-.286-10.433z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M44.361 55.504c.098 1.66.164 2.781.145 3.367-.039 1.146-.32 2.12-.82 2.854-.58-.451-1.322-1.25-1.248-2.451.295-4.641-.213-9.013-.805-13.213.498-.366 1.34-.761 1.84-1.126.996 5.656 1.332 9.169.888 10.569z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M46.467 58.542l-.57 2.157c-.039 1.146-.75 2.095-1.248 2.826-.582-.452-1.111-1.194-.965-2.389.854-6.854.549-11.389-.891-16.973 3.258 2.221 4.766 6.903 3.674 14.379z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M46.299 60.663l2.988-.989c.381 2.982-.205 6.729-1.01 11.669-.689 4.243-.326 7.601.201 9.753-3.188-.435-4.535-4.539-2.938-12.257.419-2.021.841-4.601.759-8.176z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M46.393 75.1c-.07-1.977.262-4.134.637-5.951a37.32 37.32 0 0 0 .799-7.391"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.178,
    d: "M46.418 43.116l-1.961.33c.098.42.594 2.997.686 3.436.732 3.582 1.217 7.8.662 12.427-.205 1.719-.57 3.123-1.105 4.207 2.152-.244 3.531-2.342 3.352-6 .375-4.271.211-7.668-.48-10.225-.207-.748-.859-3.57-1.154-4.175z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.178,
    d: "M47.607 43.579l-.961 1.098c.27.195-.193 1.036.057 2.67.162.927.715 2.022.83 3.205.379 3.925.379 8.837-.801 11.976 2.152-.243 2.891-2.189 2.959-5.853.059-3.026.066-6.596-.691-10.717-.158-.964-.621-1.732-1.393-2.379z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.181,
    d: "M42.234 46.467l1.984-.23c.365 1.874.645 3.199.713 3.867.133 1.31-.268 2.51-.719 3.403-.732-.438-1.072-1.403-1.381-2.752-.308-1.357-.386-2.833-.597-4.288z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M37.082 50.688l1.762.02c.061 1.616.105 2.71.076 3.281-.059 1.117-.338 2.063-.813 2.771-.535-.446-1.043-1.231-1.123-2.399-.082-1.177.086-2.427.098-3.673z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M35.186 51.521l1.76.08c.004 1.619.01 2.713-.039 3.28-.096 1.115-.408 2.052-.912 2.742-.518-.464-.994-1.267-1.035-2.438-.04-1.173.169-2.415.226-3.664zm3.691-1.742l1.758-.124c.191 1.606.324 2.693.342 3.263.033 1.119-.166 2.085-.586 2.828-.57-.398-1.139-1.143-1.313-2.301-.176-1.163-.111-2.424-.201-3.666z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.187,
    d: "M40.525 47.884l1.926-.799c.328 1.301.773 5.586-.016 7.396-.643-.436-1.291-1.252-1.506-2.541-.216-1.294-.281-2.671-.404-4.056z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.179,
    d: "M43.072 45.76l3.082.273c.709 1.765 1.174 3.33 1.4 4.748-1.432-.254-2.467-.953-2.838-2.232-.499-1.727-1.382-2.485-1.644-2.789z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M34.014 50.141c.234-.048.473-.116.717-.202-1.127-.706-2.064-1.56-3.174-3.263-1.141-1.744.498-4.861 1.17-6.513 1.402-1.039 2.727-2.563 3.145-4.574.166-1.083-2.82-.692-4.877.277-2.51 1.184-2.852.856-3.748 1.058-.316 1.537.348 1.666.99 1.591-1.385 2.216-1.961 4.423-2.238 7.597-.276-3.174-.854-5.381-2.236-7.597.641.076 1.307-.055.988-1.591-.896-.201-1.238.126-3.75-1.058-2.055-.969-5.043-1.36-4.877-.277.42 2.01 1.744 3.536 3.146 4.574.672 1.652 2.311 4.769 1.17 6.513-1.113 1.703-2.047 2.558-3.175 3.263.243.086.483.153.718.202-.17.232-1.633.688-1.804.567-1.121-.791-2.21-2.648-3.162-3.727-2.698-3.055-4.042-5.414-3.565-7.316.676-2.048 3.094-4.348-.107-3.951-3.198.397-5.852 4.783-6.704 10.06-.316 1.958-.499 3.597-.712 4.939 1.747-.623 2.521-1.245 2.985-2.009a17.543 17.543 0 0 0-.471 2.078c1.43-.253 2.464-.953 2.835-2.232.13-.453.308-.891.528-1.307.438.156 1.008.146 1.701-.023.262.627 2.23 2.817 3.289 4.428 1.193 1.816 2.988 3.207 3.58 3.283.295.036.388-.619.321-1.523 3.122.021 6.242.04 9.3-.063 3.06.104 6.177.086 9.3.063-.064.904.023 1.561.32 1.523.592-.076 2.387-1.467 3.58-3.283 1.059-1.61 3.025-3.8 3.289-4.428.693.169 1.264.179 1.701.023.191.358.377.788.525 1.307.371 1.279 1.408 1.979 2.838 2.232a16.969 16.969 0 0 0-.471-2.078c.465.765 1.238 1.386 2.984 2.009-.213-1.342-.396-2.98-.713-4.939-.854-5.277-3.504-9.662-6.705-10.06-3.199-.397-.783 1.902-.107 3.951.477 1.903-.869 4.262-3.563 7.316-.953 1.079-2.043 2.937-3.164 3.727-.165.122-1.627-.333-1.797-.567z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M32.143 41.57c.301.263 1.293.267 2.652.354 2.189.077 3.459-.583 3.738-1.983-.822.978-1.801 1.461-2.916 1.187-1.5-.372-2.359-.638-2.703-.572-.228.081-.566.497-.771 1.014z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.177,
    d: "M37.266 35.817c2.455.266 2.338 1.868.043 4.136-.439.435-.592.42-.686-.03-.164-.789-1.037-1.253-1.496-.654-.311.409-.242.643-1.283.498-1.313 1.1-2.383 1.875-.662 1.81.756-.029 1.338.412 2.322.373-.291.565-.344.629-.5.678-.957.188-1.963-.408-2.928-.23-2.109.389 3.383-5.698 3.316-5.939-.173-.613 1.323-1.711 1.874-.642z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.184,
    d: "M37.209 35.765c-.205.578-.592 1.108-1.166 1.593"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M37.732 36.943a.217.217 0 0 0-.234-.179.195.195 0 0 0-.176.213v.01c.018.112.119.19.232.179a.197.197 0 0 0 .178-.213v-.01z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.232,
    d: "M16.752 36.432c.658-.037 1.334.251 2.211.57.246.09 1.104.427 1.365.388"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M23.801 38.523a12.494 12.494 0 0 1-1.448-.304"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.233,
    d: "M17.275 36.479c.276.508.604 1.195 1.188 1.521.439.246.929-.143 1.285-.808"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M18.232 37.755l-.324-.324c-.157-.199-.065-.464.275-.796.249.107.448.191.646.273-.131.449-.33.732-.597.847z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.233,
    d: "M34.723 36.479c-.275.508-.605 1.195-1.189 1.521-.438.246-.926-.143-1.281-.808"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33.768 37.755l.32-.324c.16-.199.068-.464-.271-.796a34.29 34.29 0 0 1-.648.273c.132.449.331.732.599.847z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.232,
    d: "M35.246 36.432c-.658-.037-1.334.251-2.211.57-.246.09-1.104.427-1.365.388"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174,
    d: "M28.199 38.523c.488-.073.971-.174 1.447-.304"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.268 49.94c1.4.491 2.667.394 3.617-.541l.428-.423"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.484 48.124a8.696 8.696 0 0 1-.705 2.446c.987-.257 1.767-.711 2.246-1.392m2.957 1.842c-.771-.937-1.244-2.018-1.298-3.229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.831 47.983c.084.945.356 1.754.795 2.38.476-.359.937-.947 1.146-1.788m9.958 1.365c-1.402.491-2.668.394-3.617-.541l-.428-.423"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.516 48.124a8.76 8.76 0 0 0 .703 2.446c-.986-.257-1.768-.711-2.242-1.392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.168 47.983c-.084.945-.355 1.754-.795 2.38-.475-.359-.934-.947-1.145-1.788m-1.211 2.445c.77-.937 1.247-2.018 1.299-3.229"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.178,
    d: "M7.766 42.493c-1.111.794-3.158 6.536-3.314 8.22-.365 3.896-.35 8.719.815 11.816m38.965-20.036c1.111.794 3.158 6.536 3.316 8.22.361 3.896.35 8.719-.816 11.816"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.177,
    d: "M14.733 35.817c-2.456.266-2.339 1.868-.042 4.136.438.435.591.42.685-.03.164-.789 1.037-1.253 1.496-.654.313.409.242.643 1.282.498 1.313 1.1 2.382 1.875.664 1.81-.756-.029-1.339.412-2.325.373.293.565.346.629.502.678.954.188 1.959-.408 2.924-.23 2.11.389-3.383-5.698-3.314-5.939.173-.613-1.321-1.711-1.872-.642z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.184,
    d: "M14.792 35.765c.203.578.592 1.108 1.164 1.593"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14.268 36.943a.214.214 0 0 1 .232-.179c.108.01.188.106.178.215v.008a.215.215 0 0 1-.234.179.196.196 0 0 1-.177-.212l.001-.011z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M16.392 74.38l.056-1.61c-.646-.328-2.242.01-2.916 1.496-.84 1.854-1.634 2.84-2.641 3.709 1.459.271 2.695-.018 3.492-1.088 1.076-1.442 1.653-2.313 2.009-2.507z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.577 74.59l-1.742-.73c-.715 1.453-1.201 2.436-1.402 2.969-.396 1.047-.506 2.031-.322 2.882.708-.181 1.523-.683 2.076-1.719.554-1.04.896-2.258 1.39-3.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.079 74.59l-1.869-.285c-.336 1.586-.569 2.655-.636 3.223-.129 1.111.005 2.093.392 2.873.642-.348 1.311-1.035 1.594-2.174.284-1.144.317-2.405.519-3.637z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M18.356 72.052l1.113-.01c.65.321 1.334 1.804.545 3.229-.984 1.783-1.299 3.01-1.395 4.334-1.091-1.006-1.601-2.172-1.22-3.448.518-1.721 1.016-3.703.957-4.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.853 71.275l-1.782-.631c-.63 1.491-1.058 2.5-1.23 3.043-.334 1.067-.387 2.059-.154 2.896.695-.22 1.578-.674 2.07-1.737.492-1.071.667-2.398 1.096-3.571z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M17.642 70.035l-.392-2.421c-.408-.11-.953.845-1.483 1.403-.123.127-.265.248-.37.406-.24.355-.412.756-.505 1.174-.445 1.984-1.093 3.018-1.902 4.073 1.485-.03 2.638-.563 3.199-1.772.758-1.63 1.144-2.602 1.453-2.863z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeLinejoin: "round",
    strokeWidth: 0.179,
    d: "M36.348 75.166c.473.021 1.051.291 2.748 1.76.74 1.512 1.488 3.029 2.518 4.34.348.23.625.395.902.483.291.097 2.43.026 2.48-.063.666-.603 1.684-.172 1.344.465.266.25-.316 1.164-.783.783-.428-.348-1.918-.02-2.414-.199.188.447 1.533.738 2.475.808.861.037.805.896.447 1.554-.4.256-.07-.068-.217.119-.387.569-1.211.496-1.238-.063-.027-.578-2.037-1.329-2.338-1.772.369.877 1.217 1.694 1.641 2.554.451.457.729.547.143 1.463-.648-.074-.688-.248-1.088.131-.889-.098-1.031-.36-.887-1.063.15-.743-.471-2.086-.678-2.466-.189-.352-.238-.714-.422-.934-.324-.381-1.859-1.145-2.252-.935-.723.388-1.275.153-1.367-.548.232-.18.061-1.175.561-1.217.406-.035.65.092 1.025.396.596.485.898.743 1.092.688.463-.127-.836-.764-2.018-2.313-1.639-2.146-1.751-3.237-1.674-3.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.176,
    d: "M46.24 82.543c.594-.348.934-.334 1.164-.074.127.143.289.066.193-.154-.395-.933-1.023-1.047-1.588-.61-.139.13-.275.263-.41.397.094.138.565.336.641.441zm-8.49-.832c-.629-.429-1.221-.512-1.541-.271-.18.134-.354.037-.199-.183.652-.918 1.418-.963 1.996-.444.156.168.281.313.406.457-.201.214-.637.46-.662.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.174,
    d: "M42.707 86.971c.387.762.59 1.285.42 1.695-.096.238.018.459.258.251.982-.843.986-1.812.355-2.468-.209-.221-.434-.359-.633-.521-.255.24-.419 1.006-.4 1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C027",
    strokeWidth: 0.202,
    d: "M45.162 84.962c.586.242.787.55.768.952-.014.223.133.307.217.048.715-1.659-.027-1.969-1.1-1.909-.063.29.09.897.115.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.174,
    d: "M40.127 81.27c.389-.226.408-.473.309-.641-.213-.354-.43-.184-.832.145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.174,
    d: "M39.629 80.727c.385-.223.408-.471.307-.638-.213-.354-.43-.185-.83.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.194,
    d: "M39.068 80.213c.426-.292.451-.613.34-.832-.236-.46-.473-.238-.918.186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.202,
    d: "M38.465 79.566c.451-.33.477-.694.359-.939-.25-.52-.502-.27-.975.211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.209,
    d: "M37.83 78.879c.422-.348.553-.693.361-.999-.301-.474-.502-.286-.975.226"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 22.926,
    strokeWidth: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M35.607 74.38l-.059-1.61c.646-.328 2.242.01 2.916 1.496.84 1.854 1.635 2.84 2.643 3.709-1.459.271-2.695-.018-3.494-1.088-1.074-1.442-1.65-2.313-2.006-2.507z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.42 74.59l1.744-.73c.713 1.453 1.199 2.436 1.402 2.969.395 1.047.506 2.031.322 2.882-.709-.181-1.525-.683-2.078-1.719-.554-1.04-.894-2.258-1.39-3.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.92 74.59l1.869-.285c.336 1.586.568 2.655.635 3.223.129 1.111-.008 2.093-.391 2.873-.643-.348-1.313-1.035-1.594-2.174-.285-1.144-.318-2.405-.519-3.637z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M33.643 72.052l-1.115-.01c-.65.321-1.334 1.804-.543 3.229.982 1.783 1.297 3.01 1.395 4.334 1.09-1.006 1.6-2.172 1.217-3.448-.515-1.721-1.013-3.703-.954-4.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.146 71.275l1.781-.631c.629 1.491 1.059 2.5 1.23 3.043.336 1.067.387 2.059.154 2.896-.695-.22-1.578-.674-2.068-1.737-.493-1.071-.669-2.398-1.097-3.571z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M34.355 70.035l.391-2.421c.408-.11.955.845 1.484 1.403.123.127.264.248.371.406.24.355.412.756.504 1.174.445 1.984 1.094 3.018 1.904 4.073-1.484-.03-2.637-.563-3.199-1.772-.759-1.63-1.144-2.602-1.455-2.863z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D93A43",
    strokeWidth: 0.333,
    d: "M35.904 51.197v16.015c0 2.863-1.113 5.463-2.906 7.347-1.793 1.885-4.27 3.055-6.998 3.055-2.727 0-5.203-1.17-6.998-3.055-1.795-1.884-2.906-4.484-2.906-7.348V51.197h19.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 0.174,
    d: "M35.904 61.02v4.127h-7.842v12.235a9.443 9.443 0 0 1-4.125 0V65.146h-7.841v-4.125h7.841v-9.823h4.125v9.823l7.842-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 0.185,
    d: "M22.6 53.537v5.804c-1.266.339-4.346 1.565-4.506-1.126-.073-1.242 1.543-2.063 1.979-.963.206.52-.019.887-.322 1.006-.328.128-.653-.138-.567-.533-1.31.686 1.169 2.137 2.29.248.326-.552-.551-1.125-.551-1.535-.002-.406.86-1.018.551-1.531-1.135-1.883-3.6-.438-2.29.244-.086-.395.239-.66.567-.53.305.118.529.487.322 1.006-.436 1.099-2.052.276-1.979-.965.16-2.689 3.24-1.465 4.506-1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 0.183,
    d: "M29.4 53.537v5.804c1.264.339 4.344 1.565 4.504-1.126.074-1.242-1.543-2.063-1.979-.963-.207.52.02.887.32 1.006.33.128.654-.138.568-.533 1.309.686-1.17 2.137-2.289.248-.326-.552.551-1.125.553-1.535 0-.406-.863-1.018-.553-1.531 1.133-1.883 3.598-.438 2.289.244.086-.395-.238-.66-.568-.53-.303.118-.527.487-.32 1.006.436 1.099 2.053.276 1.979-.965-.16-2.689-3.24-1.465-4.504-1.125zm-6.8 19.092v-5.803c-1.266-.34-4.346-1.567-4.506 1.123-.073 1.242 1.543 2.063 1.979.965.206-.521-.019-.889-.322-1.006-.328-.129-.653.137-.567.531-1.31-.685 1.169-2.137 2.29-.246.326.551-.551 1.125-.551 1.533-.002.407.86 1.02.551 1.532-1.135 1.882-3.6.438-2.29-.243-.086.395.239.658.567.529.305-.119.529-.486.322-1.005-.436-1.099-2.052-.278-1.979.965.16 2.689 3.24 1.464 4.506 1.125zm6.8 0v-5.803c1.264-.34 4.344-1.567 4.504 1.123.074 1.242-1.543 2.063-1.979.965-.207-.521.02-.889.32-1.006.33-.129.654.137.568.531 1.309-.685-1.17-2.137-2.289-.246-.326.551.551 1.125.553 1.533 0 .407-.863 1.02-.553 1.532 1.133 1.882 3.598.438 2.289-.243.086.395-.238.658-.568.529-.303-.119-.527-.486-.32-1.005.436-1.099 2.053-.278 1.979.965-.16 2.689-3.24 1.464-4.504 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.333,
    d: "M35.904 51.197v16.015c0 2.863-1.113 5.463-2.906 7.347-1.793 1.885-4.27 3.055-6.998 3.055-2.727 0-5.203-1.17-6.998-3.055-1.795-1.884-2.906-4.484-2.906-7.348V51.197h19.808z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrbijaGrb);
export default __webpack_public_path__ + "static/media/srbija-grb.5a7f44d0fc685b36d4f9766f4558c493.svg";
export { ForwardRef as ReactComponent };